import { height } from '@mui/system'
import { AnimatePresence, motion } from 'framer-motion'
import React from 'react'


export default function Layout({children, path}) {
  
  return (
    <AnimatePresence mode='wait'>

      {/* Main Layout */}
      <motion.main id='layout' className={`flex flex-col justify-between items-center relative`}
      
      style={path==='/'? {height:'100vh'} : null}
      initial={{ y:-100, opacity:0 }}
      animate={{ y:0, opacity:1 }}
      exit={{ y:-100, opacity:0 }}
      transition={{ duration:1.2, ease:[0.5, 1, 0.2, 1], delay:`${
        path === '/' ? '0.3' : '0'
      }` }}
      key={path}
      >

          {children}

          {/* Index Footer */}
          {path === '/' ?
            <motion.footer className={`index-footer text-md w-full text-center pt-6 pb-4`}
              initial={{ opacity:0 }}
              animate={{ opacity:1 }}
              exit={{ opacity:0 }}
              transition={{ duration:.75, ease:[0.25, 1, 0.5, 1], delay:`${
                path === '/' ? '1.2' : '0'
              }`}}
              >
              <p className="text-sm">&#169; {new Date().getFullYear()} TurboStrat LLC. All Rights Reserved.</p>
            </motion.footer>
            :
            null
          }
      </motion.main>

      <motion.section 

        initial={{ opacity:0 }}
        animate={{ opacity:1 }}
        exit={{ opacity:0 }}
        transition={{ duration:.75, ease:[0.25, 1, 0.5, 1], delay:`${
          path === '/' ? '1.2' : '0'
        }`}}

      className={`bottom-section w-full`}>

        {/* Google Ads Banner */}
        {/* {
          path !== '/' ? 
          <div id='google-ad' className='mx-auto mb-2'>
              Google Ads Banner (Replace with Google AdSense code snippet)
          </div>
          :
          null
        } */}

        {/* Prediction Footer */}
        {path === '/' ?
            null
            :
            <motion.footer className={`index-footer text-md w-full text-center py-10 ${path === '/' ? '' : 'pred-footer'}`}
            initial={{ opacity:0 }}
            animate={{ opacity:1 }}
            exit={{ opacity:0 }}
            transition={{ duration:.75, ease:[0.25, 1, 0.5, 1], delay:`${
              path === '/' ? '1.2' : '0'
            }`}}
            >
              <ul className="flex flex-col sm:flex-row justify-center space-y-6 sm:space-y-0 sm:space-x-12 mb-10 text-base">
                <li><a className="footer-link underline underline-offset-4 font-medium" href="https://turbostrat.com/#about" target="_blank">About</a></li>
                <li><a className="footer-link underline underline-offset-4 font-medium" href="https://turbostrat.com/terms-web.html" target="_blank">Terms</a></li>
                <li><a className="footer-link underline underline-offset-4 font-medium" href="https://turbostrat.com/privacy.html" target="_blank">Privacy</a></li>
                <li><a className="footer-link underline underline-offset-4 font-medium" href="../sitemap.xml" target="_blank">Sitemap</a></li>
              </ul>
              <p className="text-sm">&#169; {new Date().getFullYear()} TurboStrat LLC. All Rights Reserved.</p>
            </motion.footer>
            }
      </motion.section>
    
    </AnimatePresence>
    
  )
}
